module.exports = __webpack_public_path__ + "static/media/гу.9a63bc79.mp3";